module.exports = __webpack_public_path__ + "img/psw-2022.42c7da46.jpg";